<script setup>
import {onMounted, reactive} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import countdown from '@/StandaloneJS/vue-countdown';
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  search: null,
  dataLoading: true,
  newAdj: false,
  headers: [
    { title: 'Person', key: 'pname' },
    { title: 'Mobile-Phone', key: 'mobile' },
    { title: 'Email', key: 'email' },
    { title: 'Tasks Pending', key: 'tname' },
    {
      title: 'Time Remaining',
      key: 'timedue',
    },
  ],
  items: [],
});

const getData = () => {
  ApiWrapper.post('tasks-pending', 'list-tasks-pending-user-dash', {})
      .then((response) => {
        if(response.tasks){
          data.items = response.tasks;
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false;
      })
}

onMounted(()=>{
  getData()
})

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pending Tasks For Users</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field v-model="data.search" append-inner-icon="mdi-magnify" label="Search" single-line hide-details class="ml-4"></v-text-field>
        </v-col>
        <v-col>
          <v-btn icon variant="flat" class="mt-1" @click="getData()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :items="data.items" :headers="data.headers" item-key="taskid" :search="data.search"
                    :loading="data.dataLoading" loading-text="Loading... Please wait">
        <template v-slot:[`item.pname`]="{ item }">
          <RouterLink :to="`/userprofile/${item.personid}`">
            {{ item.pname }}
          </RouterLink>
        </template>

        <template v-slot:[`item.timedue`]="{item}">
          <v-chip label v-if="new Date(item.timedue) - new Date() > 0" class="success text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date(item.timedue) - new Date()">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2,0) }}:{{
                  props.minutes.toString().padStart(2,0) }}:{{
                  props.seconds.toString().padStart(2,0) }}
              </template>
            </countdown>
          </v-chip>
          <v-chip label v-else-if="!item.timecompleted" class="error text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date() - new Date(item.timedue)" :interval="-1000">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2,0) }}:{{
                  props.minutes.toString().padStart(2,0) }}:{{
                  props.seconds.toString().padStart(2,0) }}
              </template>
            </countdown>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }

  .transparent {
    background: rgba(0, 0, 0, 0);
  }
</style>